export const landingPage = {
  title: 'Landing Pages',
  subtitle: 'Genera landing pages optimizadas para SEO con análisis de keywords por IA',

  actions: {
    new: 'Nuevo Proyecto',
  },

  empty: {
    title: 'No hay proyectos de landing pages aún',
    description: 'Crea landing pages optimizadas para SEO en minutos usando análisis de keywords por IA y generación automática de contenido.',
    cta: 'Crea tu primer proyecto',
    feature1: 'Análisis de keywords con IA',
    feature2: 'Anti-canibalización',
    feature3: 'Generación masiva',
  },

  stats: {
    projects: '{{count}} proyectos',
    completed: '{{count}} completados',
    pages: '{{count}} páginas total',
    projectsLabel: 'Proyectos',
    completedLabel: 'Completados',
    pagesLabel: 'Páginas Generadas',
  },

  relativeTime: {
    justNow: 'Ahora',
    minutesAgo: 'hace {minutes}m',
    hoursAgo: 'hace {hours}h',
    daysAgo: 'hace {days}d',
  },

  status: {
    draft: 'Borrador',
    analyzing: 'Analizando',
    analyzed: 'Analizado',
    generating: 'Generando',
    completed: 'Completado',
    failed: 'Fallido',
  },

  delete: {
    title: 'Eliminar Proyecto',
    description: 'Esta acción no se puede deshacer. El proyecto y todas sus landing pages se eliminarán permanentemente.',
  },

  wizard: {
    title: 'Generador de Landing Pages',
    subtitle: 'Crea landing pages optimizadas para SEO en 3 pasos',

    steps: {
      configuration: 'Configuración',
      analysis: 'Análisis de Keywords',
      generation: 'Generación de Contenido',
    },

    config: {
      sectionProject: 'Proyecto',
      sectionSources: 'Fuentes',
      sectionLayout: 'Layout',
      projectName: 'Nombre del Proyecto',
      projectNamePlaceholder: 'ej., Landing Pages de Producto Q1',
      website: 'Sitio Web',
      websitePlaceholder: 'Selecciona un sitio web...',
      websiteHint: 'Se usa para verificar canibalización contra páginas existentes',
      brandVoice: 'Voz de Marca',
      brandVoicePlaceholder: 'Selecciona una voz de marca...',
      keywordResearch: 'Investigación de Keywords',
      keywordResearchPlaceholder: 'Selecciona una investigación de keywords...',
      layout: 'Definición de Layout',
      layoutTemplate: 'Plantilla',
      layoutDescription: 'Descripción',
      layoutImage: 'Imagen',
      layoutTemplateDesc: 'Usa una estructura predefinida',
      layoutDescriptionDesc: 'Describe el layout en texto',
      layoutImageDesc: 'Sube una imagen de referencia',
      layoutDescriptionPlaceholder: 'Describe cómo quieres que se estructure la landing page...',
      layoutTemplateSoon: 'Biblioteca de plantillas próximamente. Usa el modo descripción para definir tu layout.',
      layoutImageSoon: 'Subida de imagen próximamente. Usa el modo descripción para definir tu layout.',
      createAndAnalyze: 'Crear y Analizar',
      update: 'Actualizar',
      keywordSource: 'Keywords',
      existingResearch: 'Investigación existente',
      uploadCsv: 'Subir CSV',
      csvDropzone: 'Arrastrá un CSV o hacé clic para buscar',
      csvParsed: '{{count}} keywords cargadas',
      csvTruncated: 'Mostrando las primeras 100 de {{total}} keywords',
      csvFormatHint: 'Formato CSV de Google Keyword Planner',
      csvFileTab: 'Subir Archivo',
      csvPasteTab: 'Pegar Lista',
      pastePlaceholder: 'software crm, 5400\ncrm para pymes, 2900\nherramienta email marketing\n...',
      pasteFormatHint: 'Una keyword por línea. Opcionalmente agregá el volumen después de coma o tab:\nkeyword, volumen  o  keyword\\tvolumen',
      pasteProcess: 'Procesar',
      csvParseError: 'No se pudo procesar el CSV',
      selectKeywordSourceHint: 'Seleccioná una fuente de keywords para continuar',
      selectKeywordResearchHint: 'Selecciona una investigación de keywords para continuar',
      sectionReferences: 'Materiales de Referencia',
      referenceHint: 'Subí screenshots, HTML, PDFs o DOCX para que la IA entienda la estructura de tu landing actual.',
      referenceUploadFile: 'Subir Archivo',
      referenceUploadHtml: 'Pegar HTML',
      referenceDropzone: 'Arrastrá un archivo o hacé clic para buscar',
      referenceDropzoneFormats: 'PNG, JPG, WEBP, PDF, DOCX · máx 10MB',
      referenceHtmlPlaceholder: 'Pegá el código fuente HTML...',
      referenceProcess: 'Agregar',
      referenceQueued: 'En cola',
      referenceDelete: 'Eliminar',
      referenceMaxReached: 'Máximo 5 referencias por proyecto',
      layoutReference: 'Desde Referencias',
      layoutReferenceDesc: 'Usar estructura de landing subida',
      layoutHybrid: 'Híbrido',
      layoutHybridDesc: 'Descripción + referencias',
      layoutHybridDescriptionPlaceholder: 'Describí instrucciones adicionales de layout...',
    },

    analysis: {
      readyToAnalyze: 'Listo para analizar keywords de tu investigación. Esto verificará canibalización y priorizará keywords.',
      startAnalysis: 'Iniciar Análisis',
      analyzing: 'Analizando keywords y verificando canibalización...',
      analysisSteps: {
        extracting: 'Extrayendo keywords de la investigación',
        evaluating: 'Evaluando intención de búsqueda y relevancia',
        checking: 'Verificando canibalización contra páginas existentes',
        prioritizing: 'Priorizando keywords por oportunidad',
        grouping: 'Agrupando recomendaciones',
        finishing: 'Finalizando resultados del análisis',
      },
      selectedCount: '{{count}} de {{total}} keywords seleccionadas',
      selectAll: 'Seleccionar Todas',
      deselectAll: 'Deseleccionar Todas',
      approveAndGenerate: 'Aprobar {{count}} y Generar',
      suggestedTitle: 'Título sugerido',
      alignment: 'Alineación',
      existingPageFound: 'Página existente encontrada',
      group: {
        recommended: 'Recomendadas',
        consider: 'Considerar',
        discard: 'Descartar',
      },
      showDiscarded: 'Mostrar {{count}} descartadas',
      hideDiscarded: 'Ocultar descartadas',
      tabs: {
        prioritization: 'Priorización',
        prioritizationShort: 'Prioridad',
        cannibalization: 'Canibalización',
        cannibalizationShort: 'Canibal.',
        diagnostic: 'Diagnóstico',
        diagnosticShort: 'Diag.',
        verdict: 'Veredicto y Brechas',
        verdictShort: 'Veredicto',
      },
      columns: {
        title: 'Título Sugerido',
        keyword: 'Keyword',
        volume: 'Volumen',
        intent: 'Intención',
        feature: 'Feature',
        rec: 'Rec.',
        onSite: 'En Sitio',
        featureBacking: 'Respaldo de Feature',
        landing: 'Landing',
        pillar: 'Pilar',
        exclusive: 'Exclusivo',
        overlapsWith: 'Se superpone con',
        observation: 'Observación',
        featureName: 'Feature',
        description: 'Descripción',
      },
      intent: {
        purchase: 'Compra',
        investigation: 'Investigación',
        informational: 'Informacional',
      },
      featureBacked: 'Con feature',
      noFeature: 'Sin feature',
      exclusive: 'Exclusivo',
      overlapping: 'Superpuesto',
      overlapsWithLabel: 'Se superpone con',
      verdictTitle: 'Veredicto Estratégico',
      coverageGaps: 'Brechas de Cobertura',
      allCovered: 'Todas las features de la empresa están cubiertas por las landing pages propuestas.',
      noCannibalization: 'No se detectaron riesgos de canibalización. Todas las keywords apuntan a contenido único.',
    },

    generation: {
      preparing: 'Preparando generación...',
      generatingFor: 'Generando contenido para "{{keyword}}"...',
      completedPages: 'Páginas Completadas',
      preview: 'Vista Previa',
      edit: 'Editar',
      export: 'Exportar',
      copyKeyword: 'Copiar',
      exportAll: 'Exportar Todo',
      failed: 'fallidas',
      livePreview: 'Vista Previa en Vivo',
      queued: 'en cola',
      inProgress: 'Generación en progreso',
      pagesGenerated: '{{count}} páginas generadas',
      retryFailed: 'Reintentar Fallidas',
      errorTitle: 'La generación no pudo completarse',
      errorHint: 'Intentá de nuevo con el botón "Reintentar Fallidas". Si el problema persiste, revisá la configuración del proyecto.',
      errors: {
        GENERATION_FAILED: 'El servicio de generación de contenido tuvo un error inesperado. Por favor intentá de nuevo.',
        LANDING_PAGE_INVALID_STATE: 'Este proyecto no está listo para generar. Volvé atrás y verificá tu selección de keywords.',
        LANDING_PAGE_PROJECT_NOT_FOUND: 'No se encontró el proyecto. Es posible que haya sido eliminado.',
        LANDING_PAGE_NO_APPROVED_KEYWORDS: 'No se encontraron keywords aprobadas. Volvé atrás y seleccioná al menos una.',
      },
    },
  },

  quality: {
    good: 'Calidad',
    needsImprovement: 'Revisar',
    poor: 'Baja Calidad',
  },

  references: {
    uploadSuccess: 'Referencia subida correctamente',
    uploadError: 'Error al subir la referencia',
    deleteSuccess: 'Referencia eliminada',
    deleteError: 'Error al eliminar la referencia',
  },

  preview: {
    seoTitle: 'Título SEO',
    metaDescription: 'Meta Descripción',
    h1: 'Encabezado H1',
    sections: 'Secciones',
    wireframe: 'Wireframe',
    edit: 'Editar',
    export: 'Exportar como DOCX',
    schemaMarkup: 'Schema Markup (JSON-LD)',
    copySchema: 'Copiar Schema',
    sectionsTab: 'Secciones',
    htmlPreview: 'Vista HTML',
    copyHtml: 'Copiar HTML',
    exportHtml: 'Exportar HTML',
    htmlCopied: '¡Copiado!',
    responsive: {
      mobile: 'Móvil',
      tablet: 'Tablet',
      desktop: 'Escritorio',
    },
  },

  editor: {
    title: 'Editar: {{keyword}}',
    unsavedWarning: '¿Tenés cambios sin guardar. Descartarlos?',
  },

  quickCreate: {
    title: 'Crear Landing Rápido',
    subtitle: 'Genera una landing page desde tu keyword del plan de contenido',
    back: 'Volver al plan',
    nameLabel: 'Nombre del proyecto',
    namePlaceholder: 'Landing: tu keyword',
    volume: '{{count}} búsquedas mensuales',
    generateButton: 'Generar Landing',
    dropzoneText: 'Arrastra archivos de referencia aqui o haz click para buscar',
    dropzoneHint: 'PNG, JPG, WebP, PDF, HTML — hasta {{max}} archivos',
    generating: 'Generando tu landing page...',
    generatingDescription: 'Esto puede tomar unos segundos. Estamos creando el proyecto, aprobando la keyword y generando el contenido.',
    toast: {
      success: 'Landing page generada exitosamente',
      error: 'Error al generar la landing page',
    },
  },

  toast: {
    createSuccess: 'Proyecto de landing creado exitosamente',
    createError: 'Error al crear proyecto: {{message}}',
    deleteSuccess: 'Proyecto de landing eliminado',
    deleteError: 'Error al eliminar proyecto: {{message}}',
    analysisSuccess: 'Análisis de keywords completado',
    analysisError: 'Análisis falló: {{message}}',
    approvalSuccess: 'Keywords aprobadas',
    approvalError: 'Error al aprobar keywords: {{message}}',
    exportSuccess: 'Exportación descargada exitosamente',
    exportError: 'Exportación falló: {{message}}',
  },
} as const
